import { render, staticRenderFns } from "./printConfirmation.vue?vue&type=template&id=6cb081b7&"
import script from "./printConfirmation.vue?vue&type=script&lang=ts&"
export * from "./printConfirmation.vue?vue&type=script&lang=ts&"
import style0 from "./printConfirmation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports